import { useEffect, useRef } from 'react';
import { BrokerNerdsBarkerCoreEnumsPricerStatus, getApiInventoryListing } from '../api';
import { useAuth } from '../auth/AppAuth';

export function useMessageHandlers({ isLoading }: { isLoading: boolean }) {
  const isRuleRoute = location.pathname.includes('/rule');
  const { getAccessTokenSilently, isAuthenticated } = useAuth();
  const readySent = useRef(false);
  const queue = useRef<MessageEvent[]>([]);

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type === 'bn.requestPrice') {
        const { dti_id } = event.data;
        if (!isLoading && isAuthenticated) {
          try {
            getAccessTokenSilently();
            const listingResponse = await getApiInventoryListing({
              itemId: dti_id,
            });

            if (listingResponse?.data) {
              window.parent.postMessage(
                { type: 'bn.price', data: { price: listingResponse?.data.unitPrice, dtiId: dti_id, pricerStatusId: listingResponse?.data.pricerStatusId } },
                '*',
              );
            } else {
              console.log('No price found for ', dti_id, listingResponse);
              window.parent.postMessage({ type: 'bn.price.error', data: { dtiId: dti_id, message: 'Not Found' } }, '*');
            }
          } catch (error) {
            console.log('Error getting price', error);
            window.parent.postMessage({ type: 'bn.price.error', data: { dtiId: dti_id, message: 'Error' } }, '*');
          }
        } else {
          queue.current.push(event);
          window.parent.postMessage({ type: 'bn.price', data: { price: '', dtiId: dti_id, pricerStatusId: BrokerNerdsBarkerCoreEnumsPricerStatus.None } }, '*');
        }
      }
    };

    let interval: NodeJS.Timeout;
    function processQueue() {
      interval = setTimeout(() => {
        if (isAuthenticated && !isLoading && queue.current.length > 0) {
          console.log('Processing queued messages');
          queue.current.forEach((event) => handleMessage(event));
          queue.current = [];
        }
        processQueue();
      }, 1000);
    }

    if (isRuleRoute) {
      window.addEventListener('message', handleMessage);
      if (window.self !== window.top && !isLoading && isAuthenticated && !readySent.current) {
        console.log('Sending ready message');
        readySent.current = true;
        window.parent.postMessage({ type: 'bn.ready' }, '*');
      }
      processQueue();
    }
    return () => {
      window.removeEventListener('message', handleMessage);
      clearTimeout(interval);
    };
  }, [getAccessTokenSilently, isAuthenticated, isLoading, isRuleRoute]);
}
